import React from 'react'
import PropTypes from 'prop-types';
import { Box, Grid } from "@material-ui/core";
import './tabpanel.css'

const TabPanel = ({ children, value, label, className, ...props }) => {
  return (
    <div
      role="tabpanel"
      aria-labelledby={`content-${label}`}
      className={className}
      {...props}
    >
      {value === label && (
        <Grid className="chart-drawer-content">
          <Box p={3}>{children}</Box>
        </Grid>
      )}
    </div>
  );
}
TabPanel.propTypes = {
	children: PropTypes.node,
	label: PropTypes.any.isRequired,
	value: PropTypes.any.isRequired,
	className: PropTypes.string,
};
export default TabPanel
